import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const settings = {
  // gọi đến AuthServer connect/authorize xong mới redirect về Login.js
  // authority: 'https://108.108.108.51:8989',       // your AuthServer
  authority: 'https://api.authservice.cntt108.vn',       // your AuthServer
  client_id: 'cms_qlttb',
//   client_id: 'WebApiId1992',
//   client_id: 'react_spa',
  redirect_uri: window.location.origin + '/callback',
  post_logout_redirect_uri: window.location.origin + '/',
  response_type: 'code',
  scope: 'openid profile roles offline_access webapi.cms_qlttb',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/silent-renew.html',
  silentRequestTimeoutInSeconds: 10,
  accessTokenExpiringNotificationTimeInSeconds: 30,
};

export const userManager = new UserManager(settings);

// convenience to read the currently signed in user
export function getUser() {
  return userManager.getUser();
}
